import React, {useEffect, useRef, useState} from 'react';
import "./DrShopHeader.scss";
import {
    CaretRightOutlined,
    MenuOutlined,
    LeftOutlined,
    UserOutlined,
    ShoppingCartOutlined,
    OneToOneOutlined,
    HomeOutlined,
    ApiOutlined,
    ShoppingOutlined,
    UsergroupAddOutlined,
    SearchOutlined,
    CloseCircleOutlined,
    SettingOutlined,
    AlignRightOutlined,
    CustomerServiceOutlined
} from '@ant-design/icons';
import {Col, Row, ConfigProvider, Drawer, Collapse, Menu, Space} from 'antd';
import {useScrollDistance} from "../../hooks/useScrollDistance";
import OutsideClickHandler from 'react-outside-click-handler';
import {LevelCatApi, productSearchApi, RootCatApi} from "../../Pages/DrShop/DrShopServices";
import {useHistory} from "react-router";
import {StoreOnlineSearch} from "../OnlineSerach/OnlineSearchService";
import {useBasket, useDispatchBasket, useDispatchUser, useUser} from "../../hooks";
import {GetBasket, getCatsTreeApi, getCatsTreeApi_v2} from "../OnlineAddress/OnlineAddressService";
import {getMallMerchant_api, getMallMerchant_v2_api} from "../../Services/apis";
import {NavDataApi} from "../Nav/NavServices";
import {Link, useLocation} from "react-router-dom";
import {AccessTokenData} from "../../Pages/Customer/CustomerServices";
import {getMallColor, getMallWithSubDomain} from "../../Services";
import { useQuery } from "react-query";
// import Chat from "../Chat/Chat";
import giftIcon from "../../assets/images/ph_gift.png";
import loginIcon from "../../assets/images/tabler_login.png";

import settingIcon from "../../assets/images/ep_setting.png";
import logoutIcon from "../../assets/images/logout_icon.png";
import orderIcon from "../../assets/images/order_icon.png";

const {Panel} = Collapse;
const dominantColor = "#A5D122"
const secondaryColor = "#E7EAED"
const accentColor = ""
let timer = undefined

const text = ``;

function MerchantSec(){
    const { isLoading, isError, error, data } = useQuery("merchant", e=>getMallMerchant_v2_api());
    return(
        <div className="merchant-mall">
            <h1>{data?.name}</h1>
        </div>
    )
}

function SubMegaMenu({c}) {

    const [data, set_data] = useState([])

    useEffect(() => {
        let obj = [];
        obj.push({label: c.name, key: c.uid, type: "group"})
        c.childes.forEach(i => {
            obj.push({label: i.name, key: i.uid})
        })

        set_data(obj)
    }, [])

    return (
        <Menu items={data}/>
    )
}

function chunkArray(array, chunkSize) {
    return [].concat.apply([],
        array.map(function (elem, i) {
            return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
        })
    );
}

function MegaMenu({childes, merchantId}) {

    const history = useHistory()
    const [series, set_series] = useState([])

    const handleClick = (cId) => {
        let path = `/dr-shop/search/${merchantId}/${cId}`
        history.push(path)
    }

    useEffect(() => {
        childes.forEach(i => {
            series.push({name: i.name, uid: i.uid, group: true})
            i.childes.forEach(j => {
                series.push({name: j.name, uid: j.uid, group: false})
            })
        })

        let d = chunkArray(series, 12)
        console.log("CCCC : ", d)
        set_series(d)
    }, [])


    return (
        <div className="nItem-container">
            {series.map(s => {
                return (
                    <div className="nItem-col">
                        {s.map(c => {
                            return (
                                <div className="nItem-col-sec">
                                    {c.group ? <div className="right-bullet"></div> : null}
                                    {/*<Link to={`/dr-shop/detail/${merchantId}/${product.uid}`}>*/}
                                    <span onClick={e => {
                                        handleClick(c.uid)
                                    }} className={c.group ? "nItem-bold" : "nItem"}>
                                    {c.name.substr(0, 28)}
                                    </span>
                                    {/*</Link>*/}
                                    {/*{c.group?<LeftOutlined style={{color:"#6cb0ea"}} />:null}*/}
                                </div>
                            )
                        })}

                    </div>
                )
            })}


        </div>
    )
}

function goToSearches(history, merchantId, catUid, setCloseAll,onClose=null) {
    if (setCloseAll)
        setCloseAll({uid: "".uid, status: true})
    let path = `/dr-shop/search/${merchantId}/${catUid}`
    if(onClose)
        onClose()
    history.push(path)

}

function useOutsideAlerter(ref, set_results) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                set_results([])
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

function ResultMobileSearch({goToSearch,search,results, merchantId, history, set_results}) {

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, set_results);

    return (
        <div>
            {results.length > 0 ? <div ref={wrapperRef} className="dr-shop-header-body-search-results">

                <div className="dr-shop-header-body-search-results-item"
                     onClick={() => {
                         goToSearch(search)
                     }}>
                    <span>مشاهده همه</span>
                </div>
                {results.slice(0, 5).map(r => {
                    return (
                        <div className="dr-shop-header-body-search-results-item"
                             onClick={() => {
                                 console.log("aaaaaaaaa :)")
                                 history.push(`/dr-shop/detail/${merchantId}/${r.uid}`)
                             }}>
                            <span>{r.name}</span>
                            <img src={r.image} alt=""/>
                        </div>
                    )
                })}


            </div> : null}

        </div>
    )

}


function ResultSearch({search,results,goToSearch, merchantId, history, set_results}) {

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, set_results);

    return (
        <div>
            {results.length > 0 ? <div ref={wrapperRef} className="dr-shop-header-body-search-results" onClick={e => {
                console.log("%%%%%%%%%%%%%")
            }}>

                <div className="dr-shop-header-body-search-results-item"
                     onClick={() => {
                         console.log("search : ",search)
                         goToSearch(search)
                     }}>
                    <span>مشاهده همه</span>
                </div>

                {results.slice(0, 5).map(r => {
                    return (
                        <div className="dr-shop-header-body-search-results-item"
                             onClick={() => {
                                 console.log(":))))")
                                 history.push(`/dr-shop/detail/${merchantId}/${r.uid}`)
                             }}>
                            <span>{r.name}</span>
                            <img src={r.image} alt=""/>
                        </div>
                    )
                })}


            </div> : null}

        </div>
    )

}


function RootCard({cat, closeAll, setCloseAll, merchantId, mallPrimaryColor}) {

    const [isOpen, set_isOpen] = useState(false);
    const history = useHistory()

    useEffect(() => {
        if (closeAll.status && closeAll.uid !== cat.uid) {
            set_isOpen(false)
        }
    }, [closeAll])


    useEffect(() => {
        console.log("Cat : ", cat)
    }, [])


    const handleMouseLeave = () => {
        set_isOpen(false)
        setCloseAll({uid: "".uid, status: true})
    }

    return (
        <div className="dr-shop-header-cat-main-item">
                            <span
                                onClick={() => {
                                    goToSearches(history, merchantId, cat.uid, setCloseAll)
                                }}
                                onMouseOver={() => {
                                    set_isOpen(true)
                                    setCloseAll({uid: cat.uid, status: true})
                                }}>{cat.name}</span>

            <OutsideClickHandler
                onOutsideClick={() => {
                    set_isOpen(false)
                }}
            >


                <Row>
                    {cat.childes.length > 0 ?
                        <div className="dr-shop-header-cat-main-item-collapse"
                             onMouseLeave={handleMouseLeave}
                             style={{
                                 opacity: !isOpen ? "0" : "1",
                                 transition: "all .4s",
                                 visibility: !isOpen ? "hidden" : "visible",
                             }}>
                            <div
                                className="dr-shop-header-cat-main-item-collapse-list">


                                <div className="dr-shop-header-nav-menu">
                                    {cat.childes.map(l2 => {
                                        return (
                                            <div className="dr-shop-header-nav-item">
                                                <div className="dr-shop-header-cat-main-item-collapse-item ">
                                                    <div className="dr-shop-header-cat-main-item-collapse-item-title">
                                                        <LeftOutlined/>
                                                        <h5
                                                            style={{borderRightColor: mallPrimaryColor}}
                                                            onClick={e => {
                                                                goToSearches(history, merchantId, l2.uid, setCloseAll)
                                                            }}>{l2?.name} </h5>
                                                    </div>
                                                    <div className="dr-shop-header-cat-main-item-collapse-item-sub">
                                                        {l2?.childes?.map(l3 => {
                                                            return (
                                                                <span onClick={e => {
                                                                    goToSearches(history, merchantId, l3.uid, setCloseAll)
                                                                }}>{l3?.name}</span>
                                                            )
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        : null}
                </Row>

            </OutsideClickHandler>

        </div>
    )

}


function DrShopHeader({home = false}) {

    let meId = window.location.pathname.split("/")[3]
    const [merchantId, set_merchantId] = useState(meId);
    const [merchant, set_merchant] = useState(meId);

    const [searchBarVisible, set_searchBarVisible] = useState(true);


    const [token, set_token] = useState(null)
    const getToken = () => {
        set_token(localStorage.getItem('token'))
    }

    const history = useHistory();
    const basket = useBasket();
    const user = useUser();
    const basketDispatch = useDispatchBasket();

    const location = useLocation();
    const setUser = useDispatchUser();


    const scrollDistance = useScrollDistance()
    const [height, setHeight] = useState('auto');
    const [mallLogo, set_mallLogo] = useState('');
    const [mallWhite, set_mallWhite] = useState('');


    const [mallPrimaryColor, set_mallPrimaryColor] = useState('');
    const [mallSecondaryColor, set_mallSecondaryColor] = useState('');







    useEffect(() => {
        let {primary, secondary} = getMallColor()
        set_mallPrimaryColor(primary)
        set_mallSecondaryColor(secondary)
    }, [])

    useEffect(() => {
        if (scrollDistance > 2) {
            setIsExpanded(true);
        } else {
            setIsExpanded(false);
        }

    }, [scrollDistance])

    const [isExpanded, setIsExpanded] = useState(false);
    const [accountMenuVisible, set_accountMenuVisible] = useState(false);
    const [accountMenuMobileVisible, set_accountMenuMobileVisible] = useState(false);


    const handleProfileName = () => {

        if (token) {
            let localUser = localStorage.getItem('user');
            if (localUser) {
                localUser = JSON.parse(localUser);
            }

            let userObj = localUser ? localUser : user;
            if (userObj) {
                if (userObj.first_name) {
                    return userObj.first_name + " " + userObj.last_name;
                } else {
                    return "بدون نام";
                }
            } else {
                return "بدون نام";
            }
        } else {
            return "ورود | ثبت نام"
        }

    }


    //menu functions----------------------------------------
    const [menuData, set_menuData] = useState([
        {
            label: "Electronics",
            key: "Electronics",
            icon: <ApiOutlined/>,
            children: [
                {
                    label: <MegaMenu/>,
                    key: "MegaMenu",
                    style: {height: "fit-content"}
                }
            ]
        }
    ])


    // Nav
    const [aPosition, set_aPosition] = useState({
        label: "",
        link: "home",
        image: "/navbar/home_icon.svg",
        select_image: "/navbar/home_icon_select.svg"
    })
    const [bPosition, set_bPosition] = useState({
        label: "",
        link: "store",
        image: "/navbar/_store_icon.svg",
        select_image: "/navbar/store_icon_select.svg"
    })
    const [cPosition, set_cPosition] = useState({
        label: "",
        link: "scan",
        image: "/navbar/_scan_icon.svg",
        select_image: "/navbar/scan_icon_select.svg"
    })
    const [dPosition, set_dPosition] = useState({
        label: "",
        link: "reward",
        image: "/navbar/gift_icon.svg",
        select_image: "/navbar/gift_icon_select.svg"
    })

    const getNav = async () => {
        try {
            const res = await NavDataApi()
            if (res.data.length > 0 && res.data[0].items.length > 0) {
                let data = res.data[0].items;
                // A position
                let ap = data.find(d => d.position === "right")
                if (ap)
                    set_aPosition({
                        ...aPosition,
                        label: ap.title,
                        link: ap.link_to_uid,
                        image: ap.image ? ap.image : aPosition.image,
                        select_image: ap.select_image ? ap.select_image : aPosition.select_image
                    })

                // B position
                let bp = data.find(d => d.position === "right_top")
                if (bp)
                    set_bPosition({
                        ...bPosition,
                        label: bp.title,
                        link: bp.link_to_uid,
                        image: bp.image ? bp.image : bPosition.image,
                        select_image: bp.select_image ? bp.select_image : bPosition.select_image
                    })

                // C position
                let cp = data.find(d => d.position === "left")
                if (cp)
                    set_cPosition({
                        ...cPosition,
                        label: cp.title,
                        link: cp.link_to_uid,
                        image: cp.image ? cp.image : cPosition.image,
                        select_image: cp.select_image ? cp.select_image : cPosition.select_image
                    })

                // D position
                let dp = data.find(d => d.position === "left_top")
                if (dp)
                    set_dPosition({
                        ...dPosition,
                        label: dp.title,
                        link: dp.link_to_uid,
                        image: dp.image ? dp.image : dPosition.image,
                        select_image: dp.select_image ? dp.select_image : dPosition.select_image
                    })
            }
            // set_call(true)
        } catch (e) {
            // set_call(true)
            console.log("e", e)
        }
    }

    const [currentUser, set_currentUser] = useState(null)

    //---------
    useEffect(() => {
        getNav()
        // if (!home) {
        //     basketApi()
        getToken()
        getCatsTree(merchantId)
        // } else {
        //     getMerchant()
        // }
        getMerchant()

        //auto Login
        autoLogin()

        getMallDetail()

        setLocalUser()
    }, [])


    const setLocalUser = () => {
        let localUser = localStorage.getItem('user');
        console.log("localUser : ", localUser)
        if (localUser) {
            localUser = JSON.parse(localUser);
            set_currentUser(localUser)
        }
    }

    const getMall = async (sub) => {
        try {
            return await getMallWithSubDomain(sub);
        } catch (e) {
            console.log(e)
        }
    }

    const [mall, set_mall] = useState(null)

    const getMallDetail = async () => {
        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if (parts.length === 3 && parts[0] !== "www") {
            sub = parts[0]
        } else {
            sub = "app"
        }

        isAdmin = parts[0];

        if (isAdmin === "www" || isAdmin === "test")
            isAdmin = parts[1];

        if (isAdmin === "digimaall" || isAdmin === "test" || isAdmin === "stage" || isAdmin === "localhost" || isAdmin === "apluss" || isAdmin === "app") {
            let temp = isAdmin;
            isAdmin = "digimaall";
            if (temp === "app" && parts[1] !== "apluss") {
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }
        }


        let token = localStorage.getItem("token");

        if (isAdmin !== "digimaall") {
            let malli = await getMall(sub)
            localStorage.setItem('mallId', malli.data.uid);
            localStorage.setItem('mallLogo', malli.data.header_image);
            localStorage.setItem('mall', malli.data.logo);
            localStorage.setItem('mallName', malli.data.name);
            localStorage.setItem('mall', JSON.stringify(malli.data));
            localStorage.setItem('theme', JSON.stringify({
                primary: malli.data.primary_color.color,
                secondary: malli.data.secondary_color.color,
                tertiary: malli.data.tertiary_color.color
            }));
            set_mall(malli.data)
        }
    }


    const autoLogin = () => {
        let search = new URLSearchParams(location.search)
        let token = search.get('invoice_token');
        if (token)
            getAccess(token)

    }

    const getAccess = async (t) => {
        try {
            let response = await AccessTokenData(t);
            localStorage.setItem("token", response.data.user.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            setUser(response.data.user);
        } catch (e) {
            console.log(e)
        }
    }

    const [topBanner, set_topBanner] = useState("")

    const getMerchant = async () => {
        try {
            const res = await getMallMerchant_api()
            set_merchantId(res.data.uid)
            set_topBanner(res.data.top_banner)
            set_merchant(res.data)
            basketApi(res.data.uid)
            getToken()
            getCatsTree(res.data.uid)
        } catch (e) {
            console.log(e)
        }
    }


    const [tree, set_tree] = useState([])

    // const getCatsTree = async (mmId) => {
    //
    //     try {
    //         // const resp = await getCatsTreeApi_v2(mmId)
    //
    //         const original_data = [...resp]
    //         let level1 = resp.filter(c => !c.parent)
    //         level1.forEach(l1 => {
    //             l1.childes.forEach(l2 => {
    //                 let find = original_data.find(o => o.uid === l2.uid && o.parent > 0)
    //                 if (find)
    //                     l2['childes'] = find.childes ? find.childes : []
    //                 else
    //                     l2['childes'] = []
    //             })
    //         })
    //         set_tree(level1)
    //     } catch (e) {
    //         console.log(e)
    //     }
    // }


    const getCatsTree = async (mmId) => {
        try {
            const resp = await getCatsTreeApi_v2(mmId)
            const original_data = [...resp]
            let level1 = resp.filter(c => !c.parent)
            level1.forEach(l1 => {
                l1.childes.forEach(l2 => {
                    let find = original_data.find(o => o.uid === l2.uid && o.parent > 0)
                    if (find)
                        l2['childes'] = find.childes ? find.childes : []
                    else
                        l2['childes'] = []
                })
            })
            set_tree(level1)
        } catch (e) {
            console.log(e)
        }
    }



    const basketApi = async (mId) => {
        console.log("cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc")
        const response = await GetBasket(mId);

        if (response.data.items && response.data.items.length > 0) {
            let maped = response.data.items.map(item => {
                return {count: item.quantity, product: item.product}
            })
            basketDispatch(maped)
            localStorage.setItem("basket", JSON.stringify(maped))
        } else {
            //empty
            basketDispatch([])
            localStorage.setItem("basket", JSON.stringify([]))
        }
    }


    const [rootCats, set_rootCats] = useState([])


    const getLevelCats = async (roots) => {


        try {
            const res = await RootCatApi(merchantId)
            set_rootCats(res.data)
        } catch (e) {
            console.log(e)
        }
    }


    const handleCloseAll = () => {
        console.log("")
        set_closeAll({uid: "", status: true})
    }


    const [closeAll, set_closeAll] = useState({uid: "", status: false})
    const [results, set_results] = useState([])
    const [mobileResult, set_mobileResult] = useState([])
    const [show, set_show] = useState(false)
    const [search, set_search] = useState([])


    const doSearch = async (value) => {
        set_search(value)
        if (value.length > 2) {
            try {
                let response = await productSearchApi(merchantId, value, 1);
                set_results(response.data.results);
                set_mobileResult(response.data.results);
            } catch (e) {
                console.log(e);
            }
        }

        if (value.length < 1) {
            set_results([])
            set_mobileResult([])
        }
    }


    const calculateBasket = () => {
        let count = 0;
        basket.forEach(item => {
            count += item.count
        })
        // console.log("Baskettttt", count)
        return count
    }

    useEffect(() => {
        let mLogo = localStorage.getItem('mallLogo')
        let mWhite = localStorage.getItem('mallWhite')

        console.log("VVV : ", mWhite)
        if (mLogo)
            set_mallLogo(mLogo)

        if (mWhite)
            set_mallWhite(mWhite)

    }, [])

    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    const GoTo = (page, text) => {
        history.push("/" + page, {navLabel: text});
    }

    const onEnter = (event, callback) => event.key === 'Enter' && callback()
    const enterEvent = () => goToSearch();

    const goToSearch = () => {
        if (search.length > 2) {
            set_mobileResult([])
            set_results([])
            history.push(`/dr-shop/search/${merchantId}/---?search=${search}`)
        }

    }

    const logout = ()=>{
        localStorage.removeItem("user")
        localStorage.removeItem("mobileSuggestion")
        localStorage.removeItem("token")
        localStorage.removeItem("basket")
        if(location.pathname==="/home"){
            history.go(0)
        }else {
            history.push("/home")
        }
    }

    return (
        <div className="dr-shop-header">


            {/*Mobile Header*/}

            <div className="dr-shop-header-mobile">



                <Drawer onClose={onClose} width={250} visible={open} closable={false}>

                    <div className="close-btn clickable" onClick={onClose}>
                        <CloseCircleOutlined />
                    </div>

                    <ConfigProvider direction={"rtl"}>

                        <div className="prescription-drawer-btn" onClick={e => {
                            history.push("/med-order")
                        }}>
                            <span style={{backgroundColor: mallPrimaryColor}}>سفارش نسخه</span>
                        </div>

                        {/*<div className="prescription-drawer-btn" onClick={e=>{*/}
                        {/*    if (merchantId) {*/}
                        {/*        history.push(`/referral/${merchantId}`, {item:merchant})*/}
                        {/*    }*/}
                        {/*}}>*/}
                        {/*    <span style={{backgroundColor:mallPrimaryColor}} >دعوت از دوستان</span>*/}
                        {/*</div>*/}

                        <Collapse
                            collapsible="icon"
                            bordered={false}
                            // defaultActiveKey={['1']}
                            expandIcon={({isActive}) => <CaretRightOutlined rotate={isActive ? 90 : 0}/>}
                            className="shop-menu-collapse"
                        >
                            {tree.map(l1 => {
                                return (
                                    <Panel header={(
                                        <>
                                                <span className="antd-collapse-custome-label" onClick={e => {
                                                    goToSearches(history, merchantId, l1.uid, set_closeAll,onClose)
                                                }}>{l1.name}</span>
                                        </>
                                    )} key={l1.uid} className="site-collapse-custom-panel">
                                        {l1.childes.map(l2 => {
                                            return (
                                                <Collapse collapsible="icon" defaultActiveKey="1">
                                                    <Panel header={(
                                                        <>
                                                <span className="antd-collapse-custome-label" onClick={e => {
                                                    goToSearches(history, merchantId, l2.uid, set_closeAll,onClose)
                                                }}>{l2.name}</span>
                                                        </>
                                                    )} key={l2.uid} className="site-collapse-custom-panel">
                                                        <div className="l3-list">
                                                            {l2.childes.map(l3 => {
                                                                return (
                                                                    <span onClick={e => {
                                                                        goToSearches(history, merchantId, l3.uid, set_closeAll,onClose)
                                                                    }}>{l3.name}</span>
                                                                )
                                                            })}
                                                        </div>
                                                    </Panel>
                                                </Collapse>
                                            )
                                        })}
                                    </Panel>
                                )
                            })}

                        </Collapse>
                    </ConfigProvider>

                </Drawer>

                <div className="header-top-banner-mobile">
                    <img src={topBanner} alt=""/>
                </div>

                <div style={{backgroundColor: mallPrimaryColor}} className="dr-shop-header-body-mobile-top-row">


                    <div className={"dr-shop-header-body-basket-mobile float-basket"}>

                            <span className="user-profile-icon" onClick={e => {
                                set_accountMenuMobileVisible(!accountMenuMobileVisible)
                            }}>
                                    <UserOutlined style={{fontSize: 19}}/>
                                </span>








                        <ShoppingCartOutlined
                            onClick={e => {
                                history.push(`/dr-shop/basket/${merchantId}`)
                            }}
                            style={{fontSize: 26, color: "#ffffff", cursor: "pointer"}}/>

                        <div
                            className="dr-shop-header-body-basket-badge">
                            <span>{calculateBasket()}</span>
                        </div>

                    </div>

                    <div className="header-center-content">
                        <span>{mall?.name}</span>
                        <img onClick={() => {
                            history.push(`/`)
                        }} className="dr-shop-header-body-logo-white"
                             src={mallWhite} alt=""/>
                    </div>

                    <div className="dr-shop-header-body-basket-mobile-wrapper">




                        <div className="dr-shop-header-body-basket-menu-mobile" onClick={showDrawer}>
                            <MenuOutlined style={{fontSize: 20, color: "white"}}/>
                        </div>
                    </div>
                </div>

                <div
                    style={{backgroundColor: mallPrimaryColor}}
                    className={scrollDistance > 2 ? "float-nav-mobile top-fix" : "float-nav-mobile"}>
                    <div className="dr-shop-header-body-mobile">

                        <div className="dr-shop-header-body-logo" onClick={() => {
                            history.push(`/dr-shop/online-store/${merchantId}`)
                        }}>

                            <img onClick={() => {
                                history.push(`/`)
                            }} className="dr-shop-header-body-logo-white"
                                 src={mallWhite} alt=""/>
                        </div>


                        {/*Search*/}
                        {searchBarVisible ? <div className="dr-shop-header-body-search-mobile">

                            {/*<span onClick={() => {*/}
                            {/*    goToSearch()*/}
                            {/*}}*/}
                            {/*      className={"dr-shop-header-body-search-icon-float-mobile"}>*/}
                            {/*    <SearchOutlined style={{fontSize: 18}}/>*/}
                            {/*</span>*/}


                            <input type="text"
                                   onChange={(e) => {
                                       doSearch(e.target.value)
                                   }}
                                   onKeyPress={e => onEnter(e, enterEvent)}
                                   value={search}
                                   className={"dr-shop-header-body-search-input-float-mobile"}
                                   placeholder="محصول/برند موردنظرت را جستجو کن"/>


                            <ResultMobileSearch search={search} goToSearch={goToSearch} results={mobileResult} set_results={set_mobileResult} history={history}
                                                merchantId={merchantId}/>


                            {accountMenuMobileVisible ?
                                <div className="dr-shop-header-account-mobile-menu">
                                    <div className="dr-shop-header-account-mobile-menu-header clickable"
                                         onClick={e => {
                                             history.push("/profile")
                                         }}>
                                        <div className="sdf">
                                            <LeftOutlined style={{color: "lightGray", fontSize: 12}}/>
                                        </div>
                                        <div className="dr-shop-header-account-mobile-menu-info-image">
                                            <img src={currentUser?.image} alt=""/>
                                        </div>
                                        <div className="dr-shop-header-account-mobile-menu-info" onClick={e => {
                                            history.push("/profile")
                                        }}>
                                            <div className="dr-shop-header-account-mobile-menu-info-info-name">
                                                <span>{handleProfileName()}</span>
                                            </div>
                                            <div className="dr-shop-header-account-mobile-menu-info-info-mobile">
                                                <span>{currentUser?.phone}</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="dr-shop-header-account-mobile-menu-item clickable"
                                         onClick={e => {
                                             history.push("/reward")
                                         }}>
                                        <span>سفارش ها</span>
                                        <div className="img-menu">
                                            <img src={orderIcon} alt=""/>
                                        </div>

                                    </div>
                                    <div className="dr-shop-header-account-mobile-menu-item clickable"
                                         onClick={e => {
                                             history.push("/profile")
                                         }}>
                                        <span>تنظیمات حساب کاربری</span>
                                        <div className="img-menu">
                                            <img src={settingIcon} alt=""/>
                                        </div>

                                    </div>
                                    <div className="dr-shop-header-account-mobile-menu-item clickable"
                                         onClick={e => {
                                             logout()
                                         }}>
                                        <span>خروج حساب کاربری</span>
                                        <div className="img-menu">
                                            <img src={logoutIcon} alt=""/>
                                        </div>
                                    </div>

                                    {/*<div className="dr-shop-header-account-menu-logout" onClick={e=>{*/}
                                    {/*    localStorage.clear();*/}
                                    {/*    history.push("/login")*/}
                                    {/*}}>*/}
                                    {/*    <span>خروج از حساب کاربری</span>*/}
                                    {/*</div>*/}

                                </div> : null}


                            {/*<OutsideClickHandler*/}
                            {/*    onOutsideClick={() => {*/}
                            {/*        set_accountMenuMobileVisible(false)*/}
                            {/*    }}*/}

                            {/*>*/}

                            {/*</OutsideClickHandler>*/}

                        </div> : null}


                        <div className="mall-info" style={{color: "white"}}>
                            <span className="mall-info-name">{mall?.name}</span>
                            <span className="mall-info-address">{mall?.description}</span>
                            <span className="mall-info-phone">{mall?.phone}</span>


                            {/*<span className="mall-info-name">داروخانه آنلاین دکتر صلاحی</span>*/}
                            {/*<span className="mall-info-address">نیاوران بعد از چهارراه مژده  نبش بن بست اقبال پلاک 356</span>*/}
                            {/*<span className="mall-info-phone">02122716223</span>*/}

                        </div>


                        <div

                            className="dr-shop-header-body-basket float-basket">


                            <span className="user-profile-icon" onClick={e => {
                                //toggle search bar
                                set_searchBarVisible(!searchBarVisible)
                            }}>
                                    <SearchOutlined style={{fontSize: 20}}/>
                                </span>

                            <span className="user-profile-icon" onClick={e => {
                                set_accountMenuMobileVisible(!accountMenuMobileVisible)
                                // if (token)
                                //     history.push("/profile")
                                // else
                                //     history.push("/login");
                            }}>
                                    <UserOutlined style={{fontSize: 17}}/>
                                </span>
                            <ShoppingCartOutlined
                                onClick={e => {
                                    history.push(`/dr-shop/basket/${merchantId}`)
                                }}
                                style={{fontSize: 26, color: "#ffffff"}}/>
                            <div className="dr-shop-header-body-basket-badge">
                                <span>{calculateBasket()}</span>
                            </div>

                        </div>


                        <div className="dr-shop-header-body-basket-menu-med" onClick={showDrawer}>
                            <MenuOutlined style={{fontSize: 20, color: "white"}}/>
                        </div>


                    </div>
                </div>


                <div onMouseOver={handleCloseAll} className="dr-shop-header-divider"></div>

            </div>


            {/*Desktop Heder*/}

            {!isExpanded ?
                <div className="header-top-banner">
                    <img src={topBanner} alt=""/>
                    <div className="header-top-banner-btns">
                        {/*<div className="header-top-banner-btns-item clickable" onClick={e=>{*/}
                        {/*    history.push("/med-order")*/}
                        {/*}}>*/}
                        {/*    <span>سفارش نسخه</span>*/}
                        {/*</div>*/}
                    </div>
                </div> : null
            }


            <div className="dr-shop-header-desktop">
                {/*<Row style={{backgroundColor: mallPrimaryColor}}*/}
                {/*     className={`transition-elm ${isExpanded ? 'expanded' : ''}`}>*/}
                {/*    <Col span={2}></Col>*/}
                {/*    <Col span={20}>*/}
                {/*        <div className="dr-shop-header-top">*/}
                {/*            <div className="dr-shop-header-top-items">*/}
                {/*                <div className="dr-shop-header-top-item" onClick={e => {*/}
                {/*                    history.push("/online-orders")*/}
                {/*                }}>*/}
                {/*                    <span>پیگیری سفارش</span>*/}
                {/*                    <ShoppingOutlined style={{fontSize: 17}}/>*/}
                {/*                </div>*/}


                {/*                <div className="dr-shop-header-top-item" onClick={e => {*/}
                {/*                    if (merchantId) {*/}
                {/*                        history.push(`/referral/${merchantId}`, {item:merchant})*/}
                {/*                    }*/}
                {/*                }}>*/}
                {/*                    <span>دعوت از دوستان</span>*/}
                {/*                    <UsergroupAddOutlined style={{fontSize: 17}}/>*/}
                {/*                </div>*/}


                {/*                <div className="dr-shop-header-top-item" onClick={e => {*/}
                {/*                    if (token)*/}
                {/*                        history.push("/profile")*/}
                {/*                    else*/}
                {/*                        history.push("/login");*/}
                {/*                }}>*/}
                {/*                    <span>{handleProfileName()}</span>*/}
                {/*                    <UserOutlined style={{fontSize: 17}}/>*/}
                {/*                </div>*/}
                {/*            </div>*/}


                {/*            <div className="dr-shop-header-top-items">*/}

                {/*                {dPosition.label.length > 0 ?*/}
                {/*                    <div className="dr-shop-header-top-item"*/}
                {/*                         onClick={() => GoTo(dPosition.link, dPosition.label)}>*/}
                {/*                        <span>{dPosition.label}</span>*/}
                {/*                        /!*<OneToOneOutlined style={{fontSize: 15}}/>*!/*/}
                {/*                        /!*<img className="contrast" src={dPosition.image} alt=""/>*!/*/}
                {/*                    </div> : null}*/}

                {/*                {cPosition.label.length > 0 ?*/}
                {/*                    <div className="dr-shop-header-top-item"*/}
                {/*                         onClick={() => GoTo(cPosition.link, cPosition.label)}>*/}
                {/*                        <span>{cPosition.label}</span>*/}
                {/*                        /!*<OneToOneOutlined style={{fontSize: 15}}/>*!/*/}
                {/*                        /!*<img className="contrast" src={cPosition.image} alt=""/>*!/*/}
                {/*                    </div> : null}*/}

                {/*                {bPosition.label.length > 0 ?*/}
                {/*                    <div className="dr-shop-header-top-item"*/}
                {/*                         onClick={() => GoTo(bPosition.link, bPosition.label)}>*/}
                {/*                        <span>{bPosition.label}</span>*/}
                {/*                        /!*<OneToOneOutlined style={{fontSize: 15}}/>*!/*/}
                {/*                        /!*<img className="contrast" src={bPosition.image} alt=""/>*!/*/}
                {/*                    </div> : null}*/}

                {/*                {aPosition.label.length > 0 ?*/}
                {/*                    <div className="dr-shop-header-top-item"*/}
                {/*                         onClick={() => GoTo(aPosition.link, aPosition.label)}>*/}
                {/*                        <span>{aPosition.label}</span>*/}
                {/*                        /!*<OneToOneOutlined style={{fontSize: 15}}/>*!/*/}
                {/*                        /!*<img  className="contrast" src={aPosition.image} alt=""/>*!/*/}
                {/*                    </div> : null}*/}

                {/*                <div className="order-btn">*/}
                {/*                <span onClick={e=>{*/}
                {/*                    history.push("/med-order")*/}
                {/*                }}>*/}
                {/*                    سفارش نسخه*/}
                {/*                </span>*/}
                {/*                </div>*/}
                {/*            </div>*/}


                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col span={2}></Col>*/}
                {/*</Row>*/}

                <Row style={scrollDistance > 2 ? {backgroundColor: mallPrimaryColor} : {backgroundColor: "white"}}
                     className={scrollDistance > 2 ? "float-nav" : ""}>


                    <Col span={2}></Col>


                    <Col span={20}>
                        <div className="dr-shop-header-body">


                            <div className="left-wrapper">
                                <div className="dr-shop-header-body-logo">
                                    <div onClick={e => {
                                        history.push(`/dr-shop/basket/${merchantId}`)
                                    }}
                                         className={scrollDistance > 2 ? "dr-shop-header-body-basket float-basket" : "dr-shop-header-body-basket"}>

                                        {/*<span className="dr-shop-header-body-basket-label">سبد خرید</span>*/}
                                        <ShoppingCartOutlined
                                            style={scrollDistance > 2 ? {fontSize: 26, color: "#ffffff"} : {
                                                fontSize: 26
                                            }}/>
                                        <div className="dr-shop-header-body-basket-badge">
                                            {calculateBasket() > 0 ?
                                                <span>{calculateBasket()}</span> : null
                                            }

                                        </div>

                                    </div>

                                    <div className="dr-shop-header-account-btn" onClick={e => {
                                        if (token)
                                            set_accountMenuVisible(!accountMenuVisible)
                                        else
                                            history.push("/login");
                                    }}>
                                        <span>{handleProfileName()}</span>
                                        {token ? <UserOutlined style={{fontSize: 17}}/> :
                                            <div>
                                                <img src={loginIcon} alt=""/>
                                            </div>
                                        }
                                        <OutsideClickHandler
                                            onOutsideClick={() => {
                                                set_accountMenuVisible(false)
                                            }}
                                        >

                                            {accountMenuVisible ? <div className="dr-shop-header-account-menu">
                                                <div className="dr-shop-header-account-menu-header clickable"
                                                     onClick={e => {
                                                         history.push("/profile")
                                                     }}>
                                                    <div className="sdf">
                                                        <LeftOutlined style={{color: "lightGray", fontSize: 12}}/>
                                                    </div>
                                                    <div className="dr-shop-header-account-menu-info-image">
                                                        <img src={currentUser?.image} alt=""/>
                                                    </div>
                                                    <div className="dr-shop-header-account-menu-info" onClick={e => {
                                                        history.push("/profile")
                                                    }}>
                                                        <div className="dr-shop-header-account-menu-info-info-name">
                                                            <span>{handleProfileName()}</span>
                                                        </div>
                                                        <div className="dr-shop-header-account-menu-info-info-mobile">
                                                            <span>{currentUser?.phone}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="dr-shop-header-account-menu-item clickable"
                                                     onClick={e => {
                                                         history.push("/reward")
                                                     }}>
                                                    <span>سفارش ها</span>
                                                    <div className="img-menu">
                                                        <img src={orderIcon} alt=""/>
                                                    </div>

                                                </div>
                                                <div className="dr-shop-header-account-menu-item clickable"
                                                     onClick={e => {
                                                         history.push("/profile")
                                                     }}>
                                                    <span>تنظیمات حساب کاربری</span>
                                                    <div className="img-menu">
                                                        <img src={settingIcon} alt=""/>
                                                    </div>

                                                </div>
                                                <div className="dr-shop-header-account-menu-item clickable"
                                                     onClick={e => {
                                                         logout()
                                                     }}>
                                                    <span>خروج حساب کاربری</span>
                                                    <div className="img-menu">
                                                        <img src={logoutIcon} alt=""/>
                                                    </div>
                                                </div>

                                                {/*<div className="dr-shop-header-account-menu-logout" onClick={e=>{*/}
                                                {/*    localStorage.clear();*/}
                                                {/*    history.push("/login")*/}
                                                {/*}}>*/}
                                                {/*    <span>خروج از حساب کاربری</span>*/}
                                                {/*</div>*/}

                                            </div> : null}


                                        </OutsideClickHandler>
                                    </div>

                                    <div className="dr-shop-header-btn-item clickable " onClick={e => {
                                        history.push("/reward")
                                    }}>
                                        <img src={giftIcon} alt=""/>
                                        <span>باشگاه مشتریان</span>
                                    </div>

                                </div>


                                {/*Search*/}

                            </div>


                            <div className="dr-shop-header-body-actions">

                                <div className="dr-shop-header-body-search">

                                <span
                                    onClick={() => {
                                        goToSearch()
                                    }}
                                    style={scrollDistance > 2 ? {backgroundColor: mallSecondaryColor} : {backgroundColor: mallPrimaryColor}}
                                    className={scrollDistance > 2 ? "dr-shop-header-body-search-icon-float" : "dr-shop-header-body-search-icon"}>
                                    <SearchOutlined style={{fontSize: 18}}/>
                                </span>
                                    <input type="text"
                                           onChange={(e) => {
                                               doSearch(e.target.value)
                                           }}
                                           onClick={e => {
                                               console.log(":)")
                                           }}
                                           onKeyPress={e => onEnter(e, enterEvent)}
                                           value={search}
                                           className={scrollDistance > 2 ? "dr-shop-header-body-search-input-float" : "dr-shop-header-body-search-input"}
                                           placeholder="محصول/برند  موردنظرت را جستجو کن"/>


                                    <ResultSearch search={search} goToSearch={goToSearch} results={results} set_results={set_results} history={history}
                                                  merchantId={merchantId}/>


                                </div>


                                {scrollDistance > 2 ?
                                    <img className="dr-shop-header-body-logo-white"
                                         src={mallWhite} alt="" onClick={() => {
                                        history.push(`/`)
                                    }}/> :
                                    <img className="dr-shop-header-body-logo-original" src={mallLogo} alt=""
                                         onClick={() => {
                                             history.push(`/`)
                                         }}/>
                                }

                                <div className="merchant-name-header" onClick={() => {
                                    history.push(`/`)
                                }}>
                                    <h6>{mall?.name}</h6>
                                </div>
                            </div>

                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>


                {/*<div onMouseOver={handleCloseAll} className="dr-shop-header-divider"></div>*/}


                {/*--------------------------------------------------*/}


                {merchantId!=="siKG2wq6dH"?
                    <Row style={{backgroundColor: secondaryColor}} className="dr-shop-header-cat-menu">
                        <Col span={24}>
                            <div className="dr-shop-header-cat">

                                {/*<div style={{backgroundColor:mallPrimaryColor}} className="prescription-btn"*/}
                                {/*onClick={e=>{*/}
                                {/*    history.push("/med-order")*/}
                                {/*}}>*/}
                                {/*    <span>سفارش نسخه</span>*/}
                                {/*</div>*/}


                                <div className="dr-shop-header-cat-main">
                                    <div className="tree-menu clickable" onClick={e => {
                                        history.push("/med-order")
                                    }}>
                                        <span>سفارش نسخه</span>
                                    </div>
                                    <div className="n-menu">
                                        <Menu mode="horizontal" style={{
                                            direction: "rtl", backgroundColor: "#E7EAED",
                                            width: "100%",
                                            justifyContent: "center",
                                            openKeys: 'openKeys'
                                        }}>
                                            {tree.map(t => {
                                                return (
                                                    <Menu.SubMenu onTitleClick={e => {
                                                        goToSearches(history, merchantId, t.uid)
                                                    }} style={{fontFamily: 'YekanBlack',fontSize:12}} title={t.name}>
                                                        {t.childes.length>0?
                                                            <Menu.Item key={'openKeys'} itemSelectedBg="#ffffff"
                                                                       className="modified-item"
                                                                       style={{height: "fit-content"}}>
                                                                <MegaMenu childes={t.childes} merchantId={merchantId}/>
                                                            </Menu.Item>
                                                            :null}
                                                    </Menu.SubMenu>
                                                )
                                            })}

                                        </Menu>
                                    </div>

                                    {/*{tree.map(r => {*/}
                                    {/*    return (*/}
                                    {/*        <RootCard cat={r} closeAll={closeAll} mallPrimaryColor={mallPrimaryColor}*/}
                                    {/*                  setCloseAll={set_closeAll}*/}
                                    {/*                  merchantId={merchantId}/>*/}
                                    {/*    )*/}
                                    {/*})}*/}


                                </div>

                            </div>
                        </Col>
                        {/*<Col span={2}></Col>*/}
                    </Row>
                    :null
                }
            </div>


            {/*{merchant?.uid?<div className="float-chat" >*/}
            {/*    <CustomerServiceOutlined style={{fontSize:20}} />*/}
            {/*    <div className="chat-container">*/}
            {/*        <Chat/>*/}
            {/*    </div>*/}

            {/*</div>:null}*/}

        </div>

    )

}

export default DrShopHeader;
